<script setup>
import Logo from "@/components/base/Logo.vue";
import Burger from "@/components/base/Burger.vue";
</script>

<template>
  <header class="flex align-center justify-between relative">
    <Logo />
    <Burger />
  </header>
</template>

<style scoped lang="scss">
header {
  z-index: 10;
}
</style>